import React from 'react';
import './FeaturedSection.css';

const FeaturedSection = ({ title, description, image, align = 'left', linkText = 'SEE MORE' }) => {
  if (!title || !image) {
    return null;
  }

  return (
    <section className="featured-section">
      <div className={`featured-item featured-${align}`}>
        <div className={`featured-image image-reveal ${align === 'left' ? 'slide-in-left' : 'slide-in-right'}`}>
          <img src={image} alt={title} />
        </div>
        <div className={`featured-content fade-in-up ${align === 'left' ? 'slide-in-right' : 'slide-in-left'}`}>
          <h2>{title}</h2>
          {description && <p className="featured-description">{description}</p>}
          <button type="button" className="btn-link smooth-hover">{linkText}</button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;

